const f = {
  color: {
    error: "#b83525ff",
    background: "#ffffffff",
    border: "#abb9c7ff",
    digit: {
      text: "#314351ff",
      mask: {
        border: "#d5dce1"
      },
      border: {
        default: "#c8d3deff",
        focus: "#304ddbff"
      },
      selection: "#b2d7ff"
    }
  }
};
export {
  f as verificationCode
};
